"use client";

import type { MutableRefObject } from "react";
import { useEffect, useRef } from "react";

interface UseGanttZoomLatestRefsParams {
  fitPxPerDay: number;
  pxPerDayOverride: number | null;
}

export interface GanttZoomLatestRefs {
  fitPxPerDayRef: MutableRefObject<number>;
  pxPerDayOverrideRef: MutableRefObject<number | null>;
}

export function useGanttZoomLatestRefs({
  fitPxPerDay,
  pxPerDayOverride,
}: UseGanttZoomLatestRefsParams): GanttZoomLatestRefs {
  const fitPxPerDayRef = useRef(fitPxPerDay);
  const pxPerDayOverrideRef = useRef(pxPerDayOverride);

  useEffect(() => {
    fitPxPerDayRef.current = fitPxPerDay;
  }, [fitPxPerDay]);

  useEffect(() => {
    pxPerDayOverrideRef.current = pxPerDayOverride;
  }, [pxPerDayOverride]);

  return {
    fitPxPerDayRef,
    pxPerDayOverrideRef,
  };
}
